<template>
  <div class="pagination_wrapper">
    <button
      class="prev"
      :disabled="pageNo === 1"
      @click="$emit('changePage', pageNo - 1)"
    >
      <img class="ico_prev" src="../../assets/images/ico_arrow_left.png" />
    </button>
    <span
      v-for="(page, index) in Array(this.endPage - this.startPage + 1).fill(1)"
      :class="{ page_no: true, on: startPage + index === pageNo }"
      @click="$emit('changePage', startPage + index)"
    >
      {{ startPage + index }}
    </span>
    <button
      class="next"
      :disabled="pageNo === totalPageCount"
      @click="$emit('changePage', pageNo + 1)"
    >
      <img class="ico_next" src="../../assets/images/ico_arrow_right.png" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'CharacterListPagination',
  components: {},
  props: {
    pageNo: {
      type: Number,
      required: true
    },
    totalPageCount: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      countPage: 4, // page 노출 되는 총 숫자 1부터 4까지 네 가지만 노출되도록 디자인 되어 있어서 해당 방식 사용
      startPage: 1,
      endPage: 4
    }
  },
  computed: {},
  methods: {
    calculatePage() {
      this.startPage =
        Math.floor((this.pageNo - 1) / this.countPage) * this.countPage + 1

      this.endPage = Math.min(
        this.startPage + this.countPage - 1,
        this.totalPageCount
      )
    }
  },
  beforeUpdate() {
    this.calculatePage()
  },
  mounted() {
    this.calculatePage()
  }
}
</script>

<style lang="scss" scoped>
.pagination_wrapper {
  width: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  padding: 10px 0 16px 0;
}
.page_no {
  font-family: 'Noto Sans KR';
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: #333;
  margin: 0 4px;
  cursor: pointer;
}
.page_no.on {
  border: solid 1px #707070;
  background-color: #6134f1;
  color: white;
}
.ico_prev,
.ico_next {
  width: 26px;
  height: 32px;
}
</style>
